/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  REVOKE_ADMIN: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.userList.revokeAdmin',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'REVOKE_ADMIN' },
      },
    },
    REVOKE_ADMIN: {
      invoke: {
        id: 'revokeAdmin',
        src: 'revokeAdmin',
        onDone: {
          target: 'REVOKE_ADMIN_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'REVOKE_ADMIN_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    REVOKE_ADMIN_SUCCESS: {
      on: {
        START: { target: 'REVOKE_ADMIN' },
      },
    },
    REVOKE_ADMIN_FAILED: {
      on: {
        START: { target: 'REVOKE_ADMIN' },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
